export const ROOM_CARD_GALLERY_HEIGHT_MOBILE = 206

export const COMPACT_ROOMS_AMOUNT = 5
